import http from '@/http.js';
import eventBus from '@/eventBus.js';
import store from '@/store';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useAjoutJeuRequetes({emit}) {
    const idJeuRequetes = ref('');
    const idUtilisateur = ref(store.state.idUtilisateur);
    const schemas = ref([]);
    const schema = ref({ idSchema: 1 });
    const nom = ref('');
    const description = ref('');
    const jeuRequeteData = ref({});

    const toastMessage = ref('');
    const showNotification = ref(false);
    const toastType = ref('info');
    const duration = ref(5000);

    const invalid = yup.object({
        nom: yup.string().required('Ce champ est obligatoire'),
        description: yup.string().required('Ce champ est obligatoire'),
    });

    const { handleSubmit } = useForm({
        validationSchema: invalid,
    });

    const fetchSchemas = async () => {
        schemas.value = await http.getSchema();
    };

    const handleInsertJeuRequete = handleSubmit(async (values) => {
        jeuRequeteData.value = {
            idJeuRequetes: idJeuRequetes.value,
            idUtilisateur: idUtilisateur.value,
            nom: values.nom,
            description: values.description,
            schema: schema.value,
        };

        try {
            const data = await http.insertJeuRequete(jeuRequeteData.value);
            idJeuRequetes.value = data;
            emit('close');
            eventBus.emit('reloadJeu');
            emit('notification', {
                showNotification: true,
                toastMessage: 'Le Jeu a été ajouté avec succès!',
                toastType: 'success',
            });
        } catch (error) {
            emit('notification', {
                showNotification: true,
                toastMessage: "Erreur lors de l'ajout du jeu de requêtes.",
                toastType: 'danger',
            });
        }
    });

    onMounted(() => {
        fetchSchemas();
        eventBus.on('insertJeuRequete', handleInsertJeuRequete);
    });

    onBeforeUnmount(() => {
        eventBus.off('insertJeuRequete', handleInsertJeuRequete);
    });

    const emitInsertJeuRequete = () => {
        eventBus.emit('insertJeuRequete');
    };

    return {
        idJeuRequetes,
        idUtilisateur,
        nom,
        description,
        schemas,
        schema,
        toastMessage,
        showNotification,
        toastType,
        duration,
        emitInsertJeuRequete,
    };

}
